import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/pages/PageNewsDetail.tsx");
